import { apiClient } from './client';
import type { MediaAsset, MediaAssetFilters, MediaAssetListResponse } from '@/types/mediaAssets';

export const mediaAssetsApi = {
  async list(params: MediaAssetFilters = {}): Promise<MediaAssetListResponse> {
    const { data } = await apiClient.get('/media-assets', { params });
    return data;
  },

  async upload(payload: {
    file: File;
    title?: string;
    alt_text?: string;
    description?: string;
    publish?: boolean;
    tenant_id?: string;
  }): Promise<MediaAsset> {
    const formData = new FormData();
    formData.append('file', payload.file);
    if (payload.title) formData.append('title', payload.title);
    if (payload.alt_text) formData.append('alt_text', payload.alt_text);
    if (payload.description) formData.append('description', payload.description);
    if (payload.publish) formData.append('publish', 'true');

    const { data } = await apiClient.post('/media-assets', formData, {
      params: payload.tenant_id ? { tenant_id: payload.tenant_id } : undefined,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return data.item;
  },

  async update(
    id: string,
    payload: {
      title: string;
      alt_text?: string;
      description?: string;
      publish: boolean;
      lifecycle_state?: string;
      tenant_id?: string;
    }
  ): Promise<MediaAsset> {
    const { data } = await apiClient.patch(
      `/media-assets/${id}`,
      {
        title: payload.title,
        alt_text: payload.alt_text || '',
        description: payload.description || '',
        publish: payload.publish,
        lifecycle_state: payload.lifecycle_state || 'active',
      },
      {
        params: payload.tenant_id ? { tenant_id: payload.tenant_id } : undefined,
      }
    );
    return data.item;
  },

  async remove(id: string, tenant_id?: string): Promise<void> {
    await apiClient.delete(`/media-assets/${id}`, {
      params: tenant_id ? { tenant_id } : undefined,
    });
  },
};
